<div class="panel">
  <div class="panel-heading">
    <h2 class="panel-title" tabindex="0">
      Atenção! O acesso ao Registrato mudou!
    </h2>
  </div>
  <div class="panel-body col-12">
    <section>
      <div class="alert alert-danger">
        Siga os passos abaixo:
        <ol>
          <li>
            Habilite a
            <a
              href="https://www.gov.br/governodigital/pt-br/acessibilidade-e-usuario/atendimento-gov.br/duvidas-na-conta-gov.br/ativar-a-verificacao-em-duas-etapas"
              style="color: #0000ff; text-decoration: underline"
              target="_blank">
              verificação em duas etapas
            </a>
            na área "Segurança da conta" no app gov.br
          </li>
          <li>
            Clique no botão SAIR desta página, localizado no canto direito
            superior
          </li>
          <li>
            Faça novo login no Registrato, informando o código obtido no app
            gov.br ao clicar em "Gerar código de acesso"
          </li>
        </ol>
      </div>
    </section>
  </div>
</div>
